class Gtm {
    constructor(containerId) {
        this.containerId = containerId;
        const global = window;
        global.dataLayer = global.dataLayer || [];
        global.dataLayer.push({ event: 'gtm.js', 'gtm.start': new Date().getTime() });
    }
    static getInitialQuery() {
        return sessionStorage.getItem('initialQuery') || '';
    }
    static clearDataLayer() {
        const global = window;
        const dataLayer = global.dataLayer;
        dataLayer.length = 0;
    }
    static init(containerId) {
        if (!this.instance) {
            this.instance = new Gtm(containerId);
        }
        return this.instance;
    }
    send(event, data, eventTimeout = 500) {
        return new Promise((resolve) => {
            var _a;
            const global = window;
            (_a = global.dataLayer) === null || _a === void 0 ? void 0 : _a.push(Object.assign(Object.assign({ event }, data), { eventCallback: () => {
                    resolve();
                }, eventTimeout }));
        });
    }
}
export default Gtm;
//# sourceMappingURL=Gtm.js.map